import { $api } from './useApi'

export interface ContactMessage {
    id: string
    name: string
    email: string
    subject: string
    message: string
    createdAt: string
    isRead: boolean
    status: string
}

export const useContactService = () => {
    const getMessages = async () => {
        return await $api<ContactMessage[]>('/contact', {
            method: 'GET'
        })
    }

    const markAsRead = async (id: string) => {
        return await $api<ContactMessage>(`/contact/${id}/read`, {
            method: 'PUT'
        })
    }

    const deleteMessage = async (id: string) => {
        return await $api<{ success: boolean }>(`/contact/${id}`, {
            method: 'DELETE'
        })
    }

    return {
        getMessages,
        markAsRead,
        deleteMessage
    }
}
